import {mutations} from "@/root-store/mutations"
import {actions} from "@/root-store/actions";
import {getters} from "@/root-store/getters";

import PanelSettings from "@/modules/PanelSettings/store/index";
import UserManager from "@/modules/UserManager/store/index";
import Clients from "@/modules/Clients/store/index";
import RecruitmentSources from "@/modules/RecruitmentSources/store/index";
import SubPanels from "@/modules/SubPanels/store/index";
import Chat from "@/modules/Chat/store/index";
import DashBoard from "@/modules/Dashboard/store/index";
import Health from "@/modules/Health/store/index";
import ProjectManager from "@/modules/ProjectManager/store/index";
import DynamicProfiling from "@/modules/DynamicProfiling/store/index";

const state = {

    timezones: [],
    timezonesLoading: false,

    dataVariableTypes: ['text', 'keyword', 'email', 'radio', 'checkbox', 'date', 'number', 'locale','phone'],
    dataVariableIcons: {
        radio: "mdi-radiobox-marked",
        checkbox: "mdi-checkbox-marked-outline",
        text: "mdi-text-subject",
        keyword: "mdi-format-color-text",
        date: "mdi-clock",
        email: "mdi-at",
        number: "mdi-numeric-7-box-outline",
        locale: "mdi-map-marker",
        phone: "mdi-cellphone"
    },

    dataVariables: [],
    dataVariablesLoading: false,
    dataVariablesLoaded: false,
    dataVariablesExpire: null,

    user: {
        id: null,
        name: null,
        email: null,
        country_code: null,
        phone: null,
        timezone: null,
        timeFormat: null,
        dateFormat: null,
        roles: [],
        permissions: []
    },

    // Echo client instance
    echo: null,

    session: {
        auth: false,
        impersonator: null,
    },

    settings: {
        socketServerAddress: null,
        applicationName: null,
        environment: null
    },

    userLoading: false,
    userExpire: null,

    environment: null,

    // Announcements
    allAnnouncements: [],
    announcements: [],
    notifications: [],
    loading: false,
    expires: null,
    expiresAnnouncements: null,

    // Active vs Engaged
    activeEngaged: {
        active: {
            count: 0,
            percent: 0
        },
        engaged: {
            count: 0,
            percent: 0
        },
        all: {
            count: 0
        }
    },

    activeEngagedExpires: null,
    activeEngagedLoading: false,

    ageGenderExpires: null,
    ageGenderLoading: false,
    ageGender: []
};

export default {
    state,
    mutations,
    actions,
    getters,

    // Static non dynamic modules
    modules: {
        namespaced: true,
        PanelSettings,
        UserManager,
        Clients,
        RecruitmentSources,
        SubPanels,
        Chat,
        DashBoard,
        Health,
        ProjectManager,
        DynamicProfiling,
    }
};